<template>
  <div>
    <CSPassword
      id="input_changePassword_password"
      :label="translate(passwordPlaceholderKey)"
      :rules="[rules.required, rules.min_newPassword]"
      :onChange="updatePassword"
      :passwordDisplay="showPassword"
      @displayPassword="
        () => {
          this.showPassword = !this.showPassword
        }
      "
    >
      <v-icon :color="newPasswordCorrect ? 'success' : 'error'">
        {{ newPasswordCorrect ? 'done' : !!password ? 'clear' : '' }}
      </v-icon>
    </CSPassword>

    <CSPassword
      id="input_changePassword_repeatPassword"
      :label="translate(repeatPasswordPlaceholderKey)"
      :rules="[rules.required, rules.passwordMin, rules.checkPasswords]"
      :onChange="updateRepeatPassword"
      :passwordDisplay="showPassword"
      @displayPassword="
        () => {
          this.showPassword = !this.showPassword
        }
      "
    >
      <v-icon :color="newPasswordRepeatedCorrect ? 'success' : 'error'">
        {{ newPasswordRepeatedCorrect ? 'done' : !!password ? 'clear' : '' }}
      </v-icon>
    </CSPassword>
  </div>
</template>

<script>
import CSPassword from '@/components/atoms/form/CSPassword.vue'
import FormValidation from '@/mixins/validation'

export default {
  name: 'MatchPassword',
  mixins: [FormValidation],

  components: {
    CSPassword,
  },

  props: {
    onPasswordChange: {
      type: [Function, Number, Boolean],
    },

    onRepeatPasswordChange: {
      type: [Function, Number, Boolean],
    },

    passwordPlaceholderKey: {
      type: String,
      default: 'INPUTPLACEHOLDER_RESETPASSWORD_NEWPASSWORD',
      required: false,
    },

    repeatPasswordPlaceholderKey: {
      type: String,
      default: 'INPUTPLACEHOLDER_RESETPASSWORD_NEWPASSWORD',
      required: false,
    },
  },

  data() {
    return {
      password: '',
      repeatPassword: '',
      showPassword: false,
      newPasswordCorrect: false,
      newPasswordRepeatedCorrect: false,

      rules: {
        min_newPassword: value => {
          this.newPasswordRepeatedCorrect = this.equalsPasswords(
            value,
            this.repeatPassword,
          )

          if (value.length >= 8) {
            this.newPasswordCorrect = true
            return true
          }

          this.newPasswordCorrect = false
          return this.translate('ERRORVALIDATION_PASSWORDMIN')
        },
        checkPasswords: value => {
          if (this.equalsPasswords(this.password, value)) {
            this.newPasswordRepeatedCorrect = true
            return true
          }

          this.newPasswordRepeatedCorrect = false
          return this.translate('ERRORVALIDATION_RESETPASSWORD_CONFIRMPASSWORD')
        },
      },
    }
  },

  methods: {
    equalsPasswords(firstPassword, secondPassword) {
      return (
        !!firstPassword && firstPassword.localeCompare(secondPassword) === 0
      )
    },

    updatePassword(password) {
      this.password = password
      this.onPasswordChange(password)
    },

    updateRepeatPassword(password) {
      this.repeatPassword = password
      this.onRepeatPasswordChange(password)
    },
  },
}
</script>
